import LineBankRouter from 'app-router/linebank/linebank-router';

export default LineBankRouter;
